import { Select } from 'antd';
import { omit } from 'lodash';
import useHttpClient from 'hooks/useHttpClient';
import { useQuery } from '@tanstack/react-query';
import { masterDataKeys } from 'features/lost-found-management/keys';
import { appApiMasterIndices } from 'configs/variables';

const { Option } = Select;

export function SpSelectItemColor(props) {
  const { data, isLoading } = useSpSelectItemColor();

  return (
    <Select
      {...props}
      placeholder="เลือกสี"
      showSearch
      labelInValue
      loading={isLoading}
      onChange={(value, option) => {
        props?.onChange?.(value, option);
        const selectedColor = data?.find((ss) => ss.id === value.value);

        if (value.value === 'all') {
          const x = {
            label: 'All',
            value: 'all',
          };
          props?.onChange?.(x, option);
        }

        if (selectedColor) {
          const x = {
            ...selectedColor,
            ...omit(value, ['disabled', 'title']),
          };

          props?.onChange?.(x, option);
        }
      }}
    >
      {data?.map((ss, index) => (
        <Option key={index} value={ss.id}>
          {ss.label_en}
        </Option>
      ))}
    </Select>
  );
}

export function useSpSelectItemColor() {
  const { get } = useHttpClient();
  const queryRequest = useQuery({
    queryKey: masterDataKeys.selectColor.queryKey,
    queryFn: async () =>
      await get({
        url: `${appApiMasterIndices}/attribute?attribute_type_id=1`,
      }),
    select: (res) => {
      const { response } = res;
      return response?.data || undefined;
    },
  });

  return queryRequest;
}
